import React from 'react';

const YouTubeEmbed = React.forwardRef(({
    videoId,
    title = "YouTube video player",
    className = "relative w-full h-0 pb-[56.25%] m-auto rounded-2xl border border-black overflow-hidden",
    allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen",
    ...props
}, ref) => {
    YouTubeEmbed.displayName = 'YouTubeEmbed';
    if (!videoId || typeof videoId !== 'string' || videoId.length !== 11) {
        console.error('Invalid YouTube video ID provided to YouTubeEmbed component');
        return (
            <div className={`${className} flex items-center justify-center bg-gray-200 text-gray-600`}>
                <span>Invalid video ID</span>
            </div>
        );
    }

    const embedUrl = `https://www.youtube.com/embed/${videoId}`;

    return (
        <div className={className} ref={ref}>
            <iframe
                src={embedUrl}
                title={title}
                width="100%"
                height="100%"
                allow={allow}
                className="absolute top-0 left-0 w-full h-full"
                {...props}
            />
        </div>
    );
});

export default YouTubeEmbed;
